export default __webpack_public_path__ + "static/media/buildings.73fc9212.svg";